import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { AxiosError } from 'axios';
import { useIntercom } from 'react-use-intercom';
import { intercomEvents } from '../intercom-events';
import { User } from '../types/user';

async function resetMFA(profileUserId: string): Promise<void> {
    const { data } = await api.delete(`/users/${profileUserId}/mfa`);
    return data;
}

export function useResetMFA(profileUser: User, adminUpdatingUser: boolean): UseMutationResult<void, AxiosError, void, unknown> {
    const { trackEvent } = useIntercom();

    return useMutation(() => resetMFA(profileUser.id), {
        onSettled: () => {
            queryClient.invalidateQueries(['users', profileUser.id]);
        },
        onSuccess: () => {
            if (adminUpdatingUser) {
                trackEvent(intercomEvents.user.adminResetMFA.event, intercomEvents.user.adminResetMFA.metaData(profileUser));
            } else {
                trackEvent(intercomEvents.user.userResetMFA.event, intercomEvents.user.userResetMFA.metaData);
            }
        },
    });
}
